import {PATHS} from "@/constants/routes";
import {useAuthStore} from "@/store/authStore";
import {Navigate, Outlet} from "react-router";

export const PrivateRoute = () => {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate
      to={PATHS.LOGIN}
      replace
    />
  );
};
